import React from 'react'

const Loading = () => {
  return (
    <div className='loading-page'>
      <img src='/gif/load.gif' alt='loading' />
      <div className='loading'>
        <div className='layer1'></div>
        <div className='layer2'></div>
        <div className='layer3'></div>
        <div className='layer4'></div>
        <div className='layer5'></div>
        <div className='layer6'></div>
      </div>
    </div>
  )
}
export default Loading
